<template>
  <div class="middle">
    <!-- 网站图片 -->
    <div class="middle_center">
      <router-link :to="{name: 'index'}">
        <img class="logo"
             :src="common.showPic(logo)"
             alt='网站Logo'
             onerror="@/assets/images/LOGO.png">
      </router-link>
      <!--  搜索部分 -->
      <div class="search_box ">
        <ul class="search_con">
          <li :class="searchTypes === '1'? 'back_primary': ''"
              @click="toggleSwitch('1')">商品
          </li>
          <li :class="searchTypes === '2'? 'back_primary': ''"
              @click="toggleSwitch('2')">店铺
          </li>
          <li :class="searchTypes === '3'? 'back_primary': ''"
              @click="toggleSwitch('3')">服务
          </li>
        </ul>
        <div class="search_cart">
          <div class='search_info'>
            <div class="my_input">
              <Input v-model.trim="searchName"
                     :placeholder="placeholderVal"
                     style="width:508px;" />
              <div class="my_upload">
                <single-upload @handleUpload="handleUpload">
                  <Icon type="md-camera"
                        size="22"
                        color="#808695" />
                </single-upload>
              </div>
            </div>
            <router-link v-if="searchTypes === '1'"
                         :to="{path: 'searchGoods', query: {key: searchName.replace(/\s*/g,'')}}"
                         class="search_logo back_primary"
                         target="_self">
              <img src='@/assets/images/search.png' alt='搜索' />
            </router-link>
            <router-link v-else-if="searchTypes === '2'"
                         :to="{path: 'searchShop', query: {key: searchName.replace(/\s*/g,'')}}"
                         class="search_logo back_primary"
                         target="_self">
              <img src='@/assets/images/search.png' alt='搜索' />
            </router-link>
            <router-link v-else
                         :to="{path: 'service/serviceMarket', query: {key: searchName.replace(/\s*/g,'')}}"
                         class="search_logo back_primary"
                         target="_self">
              <img src='@/assets/images/search.png' alt='搜索' />
            </router-link>
          </div>
        </div>
        <!-- 热门词汇 -->
        <ul class="search_history">
          <li v-for="(item,index) in vocabularyList"
              :key="index">
            <router-link :class="(searchName && searchName == item) || (!searchName && index === 0) ? 'primary': ''"
                         :to="{path: '/searchGoods', query: {key: item}}"
                         target="_blank">{{item}}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="order_slider">
        <div class="middle_right"
             v-for="(item, index) in rightBanner"
             :key="index">
          <a :href="item.linkValue"
             target="_blank">
            <img :src="common.showPic(item.adPic)"
                 :alt="item.adName"
                 :title="item.adName"
                 :onerror="common.defaultImg()">
          </a>
        </div>
        <!-- <div class="slogan">
          <span></span>鞋库资讯
        </div> -->
      </div>
      <!--  全部订单滚动 -->
      <!-- <div class="order_slider"
           v-if="orderData && orderData.length> 0"> -->
      <!-- Using the slider component -->
      <!-- <slider ref="slider"
                :options="options"
                @slide='slide'
                @init="init"> -->
      <!-- slideritem wrapped package with the components you need -->
      <!-- <slideritem v-for="(item,index) in totalPage"
                      :key="index">
            <Row class="slider">
              <Col class="slider_item primary ellipsis"
                   v-for="(order,order_index) in orderData"
                   :key="order_index"> {{order.memberUsername}},刚刚完成了{{order.totalAmount}}元采购
              </Col>
            </Row>
          </slideritem>
        </slider>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SingleUpload from '@/components/Upload/SingleUpload'
import { configData, getHomeOrder, getBannerList } from '@/api/index'
// import { slider, slideritem } from 'vue-concise-slider'

export default {
  name: 'MiddleSearch',
  components: {
    SingleUpload,
    // slider,
    // slideritem
  },
  data () {
    return {
      logo: require('@/assets/images/LOGO.png'),
      searchName: '', // 搜索关键词
      vocabularyList: [], // 搜索历史]
      animateUp: false,
      orderData: [],
      searchTypes:'1',
      placeholderVal:'请输入产品关键词或货号',
      rightBanner: [],   // 右侧广告
      totalPage: null, //几页数据
      //Slider configuration [obj]
      options: {
        currentPage: 0,//当前页码
        thresholdDistance: 100,//滑动判定距离
        speed: 3000,
        thresholdTime: 3000,//滑动判定时间
        autoplay: 5000,//自动滚动[ms]
        loop: true,//循环滚动
        direction: 'vertical',//方向设置，垂直滚动
        loopedSlides: 1,//无限滚动前后遍历数
        slidesToScroll: 1,//每次滑动项数
        pagination: false,
        freeze: false
      }
    }
  },
  mounted () {
    // 获取热门词汇
    this.getHotVocabularyList()
    this.getBanner()
    if (this.$route.query.name) {
      this.searchName = this.$route.query.name
      this.$store.commit('SET_SEARCH_TYPE', '1')
    } else if (this.$route.query.skuCode) {
      this.searchName = this.$route.query.skuCode
      this.$store.commit('SET_SEARCH_TYPE', '2')
    }
    this.getHomeOrder()
    if (this.$store.state.mallLogo) {
      this.logo = this.$store.state.mallLogo
    }
  },
  methods: {
    init (data) {
      this.getHomeOrder(1)
    },
    // 获取广告
    getBanner () {
      getBannerList({ adPositionTypes: '4000' }).then(res => {
        this.rightBanner = res.data.list
      })
    },
    getHomeOrder (currentPage) {
      let params = {
        pageSize: 4,
        pageNum: currentPage,
      }
      getHomeOrder(params).then(res => {
        this.orderData = res.data.list
        this.totalPage = res.data.totalPage
      })
    },
    toggleSwitch (value) { // 搜索条件
      this.searchTypes = value
      if(value == '1'){
        this.placeholderVal = '请输入产品关键词或货号'
      }else if(value == '2'){
        this.placeholderVal = '请输入店铺名称'
      }else if(value == '3'){
        this.placeholderVal = '请输入服务名称'
      }
      this.$store.commit('SET_SEARCH_TYPE', value)
    },
    getHotVocabularyList () {
      configData({ key: 'X_searchKeywords', tips: '首页搜索显示的关键字' }).then(res => {
        let list = res.data.name.split(' ')
        this.vocabularyList = list
      })
    },
    slide (data) {
      this.orderData.length > 0 && this.getHomeOrder(data.currentPage)
    },
    handleUpload (url) {
      this.$router.push({
        path: '/searchImage',
        query: { url: url }
      })
    }
  },
  computed: {
    ...mapState(['username', 'cartnum'])
  },
  watch: {
    $route: {
      handler (value) {
        if (value.query.key) {
          this.searchName = value.query.key;
        } else {
          this.searchName = ''
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.middle {
  min-width: 1200px;
  width: 100%;
  padding: 0;
}

.middle .middle_center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  width: 1200px;
  padding: 0 10px;

  .logo {
    width: auto;
    height: 70px;
    margin-right: 100px;
    object-fit: contain;
  }
}

.search_box {
  text-align: left;
}

.search_con {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  li {
    margin-right: 5px;
    font-size: 12px;
    cursor: pointer;
    line-height: 26px;
    text-align: center;
    background: #f0f0f0;
    width: 52px;
    height: 26px;
    border-radius: 4px 4px 0 0;
  }
}

.search_cart {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.search_info {
  width: 594px;
  margin-right: 20px;
  display: flex;
  align-items: center;

  .my_input {
    position: relative;
  }

  .my_upload {
    position: absolute;
    right: 5px;
    top: 5px;
  }
}

.search_logo {
  width: 84px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 4px 4px 0;

  img {
    width: 17px;
  }
}

.search_history {
  font-size: 13px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 7px;
}

.search_history li {
  padding: 0 7px;

  a {
    color: #666666;
  }
}

/*订单滚动*/
.order_slider {
  height: 120px;
  width: 350px;

  .slider {
    background: #f5f5f5;
    width: 100%;
    height: 100%;
    /*padding: 10px 0;*/
  }

  .slider_item {
    font-size: 14px;
    line-height: 30px;
    text-align: center;
  }
}
.middle_right {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 120px;
  overflow: hidden;
  img {
    width: 150px;
    height: 100px;
    object-fit: contain;
  }
}
.slogan {
  text-align: left;
  margin: 15px 0 0 25px;
  font-size: 14px;
  font-weight: 700;

  span {
    border: 1px solid #999999;
    background: #999999;
    margin-right: 20px;
  }
}
</style>
